import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography
} from '@mui/material';
import {} from 'react-feather';

import NavItem from './NavItem';
import User from 'src/assets/user_icon.png';
import { makeStyles } from '@mui/styles';
import trainerLogo from 'src/icons_images/ic_trainer@3x.png';
import UsersIcon from 'src/icons_images/ic_All_Members@3x.png';
import MessageCircleIcon from 'src/icons_images/ic_messages@3x.png';
import BookIcon from 'src/icons_images/ic_records_white@3x.png';
import HelpCircleIcon from 'src/icons_images/ic_Total_Query@3x.png';
import BatchesIcon from 'src/icons_images/batches.png';
import MembershipIcon from 'src/icons_images/membership-plan.png';

const items = [
  // {
  //   href: '/app/dashboard',
  //   icon: BarChartIcon,
  //   title: 'Dashboard'
  // },
  {
    href: '/app/gym',
    icon: trainerLogo,
    title: 'All Gyms'
  },
  {
    href: '/app/records',
    icon: BookIcon,
    title: 'Records'
  },
  {
    href: '/app/members',
    icon: UsersIcon,
    title: 'Members'
  },
  {
    href: '/app/message',
    icon: MessageCircleIcon,
    title: 'Message'
  },
  {
    href: '/app/queries',
    icon: HelpCircleIcon,
    title: 'Queries'
  },
  {
    href: '/app/queries-follow-ups',
    icon: HelpCircleIcon,
    title: 'Follow Ups'
  },
  {
    href: '/app/trainer',
    icon: trainerLogo,
    title: 'Trainer'
  },
  {
    href: '/app/batches',
    icon: BatchesIcon,
    title: 'Batches'
  },
  {
    href: '/app/membership',
    icon: MembershipIcon,
    title: 'Mebmbership Plans'
  },
  {
    href: '/app/earnings',
    icon: MembershipIcon,
    title: 'Earnings'
  },
  {
    href: '/app/diet-plan',
    icon: MembershipIcon,
    title: 'Diet Plan'
  },
  {
    href: '/app/annivesaries',
    icon: BatchesIcon,
    title: 'Annivesaries'
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: theme.spacing(4)
  }
}));

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const { user } = useSelector((state) => state.common);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const classes = useStyles();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleClick = () => {
    setOpen(!open);
  };

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 2
        }}
      >
        <Avatar
          component={RouterLink}
          src={user.profile_pic || User}
          sx={{
            cursor: 'pointer',
            width: 64,
            height: 64,
            marginBottom: 0.8
          }}
          to="/app/account/edit"
        />
        <Typography color="textPrimary" variant="h5">
          {user.full_name}
        </Typography>
        <Typography color="textSecondary" variant="body2">
          {user.gym_name}
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <List className={classes.root} component="nav">
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
              open={open}
              handleClick={handleClick}
              collapsable={item.collapsable}
            />
          ))}
        </List>
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256,
              scrollbarWidth:'none'
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            style: {
              width: 256,
              top: 64,
              height: 'calc(100% - 64px)',
              scrollbarWidth:'none'
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default DashboardSidebar;
